import React from "react";
import moment from "moment";
import Stars from "react-stars";
import { Container } from "components/generic/layout";
import { Overlay } from "components/common/insider";

export default ({ reviews, rating }) => {
  return (
    <Overlay>
      <Container>
        <div className="pv5">
          <div className="mb4">
            {!!rating.data.value && (
              <React.Fragment>
                <div className="fw6 mb2">Your average rating</div>
                <div className="bg-white pa3 br2 f6 overflow-auto mb4">
                  <Stars
                    count={5}
                    size={16}
                    value={rating.data.value}
                    edit={false}
                    color="#ffd700"
                  />
                </div>
              </React.Fragment>
            )}
            <div className="fw6 mb2">Your reviews</div>
            {!reviews.data.length
              ? "You have no reviews"
              : reviews.data.map((review, i) => (
                  <div
                    className="bg-white pa3 br2 f6 overflow-auto mb4"
                    key={i}
                  >
                    <div className="mb1">
                      <span className="fw6">{review.reviewer_name}</span> at{" "}
                      {moment(review.created_at).format(
                        "ddd, MMM Do, YYYY - h:mm A"
                      )}
                    </div>
                    <Stars
                      count={5}
                      size={16}
                      value={review.rate.value}
                      edit={false}
                      color="#ffd700"
                    />
                    <div className="mt1">{review.general_feedback}</div>
                  </div>
                ))}
          </div>
        </div>
      </Container>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/Insider/Reviews/View.js